import { executePostEndpoint } from "./executPostEndpoint";

export const createProject = async (project, jwtToken) => {

    const response = await executePostEndpoint(project, jwtToken, 'createProject');
    console.log(response);

    return response;
};